export enum AnimationStatus {
    INCOMING,
    ONGOING,
    FINISHED
}
